import { DocumentNode } from 'graphql';
import { GQL } from 'rewire-graphql';
import { notifications } from '../ui/Notifications';
import { client as create, uploadMiddleware } from 'rewire-graphql';

const mapToUserMessage = (ex: any): string => {
  if (!ex.message) return ex;

  switch (ex.message.toLowerCase()) {
    case 'failed to fetch':
      return 'Connection to server lost - unavailable to communicate';

    default:
      return ex;
  }
};

export let baseUrl: string;
switch (window.location.hostname) {
  case '10.82.33.109':
  case 'localhost':
  case '100.76.13.102':
  case 'client-svc':
    baseUrl = `http://${window.location.hostname}:3010`;
    // baseUrl = 'http://10.0.0.197:3010';
    // baseUrl = 'https://dev.worksight.services';
    // baseUrl = 'https://test-api.worksight.services';
    break;
  default:
    baseUrl = `${window.location.protocol}//${window.location.hostname}`;
    break;
}

const graphql = `${baseUrl}/graphql`;
export const graphqlClient = create(graphql);
graphqlClient.use(uploadMiddleware);

type IExceptionCallback = (err: Error) => Promise<boolean>;
const _onExceptionHandlers: IExceptionCallback[] = [];

export function onExceptionListen(callback: IExceptionCallback) {
  _onExceptionHandlers.push(callback);
  return () => {
    const idx = _onExceptionHandlers.indexOf(callback);
    if (idx >= 0) _onExceptionHandlers.splice(idx, 1);
  };
}

export const guardedQuery = async (q: DocumentNode, variables?: Record<string, unknown>, headers?: Record<string, unknown>) => {
  try {
    return await graphqlClient.query(q as unknown as GQL, variables, headers);
  } catch (ex: any) {
    let showUserMessage: boolean = true;
    for (const handler of _onExceptionHandlers) {
      if (!(await handler(ex))) showUserMessage = false;
    }
    if (showUserMessage) {
      const message = mapToUserMessage(ex);
      notifications.error(message);
      throw ex;
    }
  }
};

export const guardedMutation = async (
  query: DocumentNode,
  variables: Record<string, unknown>,
  headers?: Record<string, unknown>,
) => {
  try {
    return await graphqlClient.mutation(query as any, variables, headers);
  } catch (ex: any) {
    let showUserMessage: boolean = true;
    for (const handler of _onExceptionHandlers) {
      if (!(await handler(ex))) showUserMessage = false;
    }
    if (showUserMessage) {
      const message = mapToUserMessage(ex);
      notifications.error(message);
      throw ex;
    }
  }
};

export const query = async (q: DocumentNode, variables?: Record<string, unknown>, headers?: Record<string, unknown>) => {
  try {
    return await graphqlClient.query(q as unknown as GQL, variables, headers);
  } catch (ex) {
    const message = mapToUserMessage(ex);
    notifications.error(message);
    throw ex;
  }
};

export const mutation = async (query: DocumentNode, variables: Record<string, unknown>, headers?: Record<string, unknown>) => {
  try {
    return await graphqlClient.mutation(query as any, variables, headers);
  } catch (ex) {
    const message = mapToUserMessage(ex);
    notifications.error(message);
    throw ex;
  }
};

export const subscribe = (query: GQL, variables: Record<string, unknown> | undefined, callback: any, field: string) => {
  const subscription = graphqlClient.subscribe(query, variables);
  const observable$ = subscription.subscribe({
    next(result: any) {
      callback(result?.data?.[field]);
    },
    error(err: Error) {
      notifications.error(err);
    },
    // complete value parameter is deprecated
    complete(_value?: any) {},
  });
  return observable$;
};
